import PropTypes from 'prop-types';
import { FormattedMessage } from 'gatsby-plugin-intl';

import {
  BreadcrumbWrapper,
  BreadcrumbContainer,
  BreadcrumbLink,
} from './styles';

const FaqBreadcrumb = ({ category, themes }) => {
  return (
    <BreadcrumbWrapper>
      <BreadcrumbContainer>
        <BreadcrumbLink url="/faq" className="content" themes={themes}>
          <FormattedMessage id="FaqHomePage" />
        </BreadcrumbLink>
        {category && <p>{category}</p>}
      </BreadcrumbContainer>
    </BreadcrumbWrapper>
  );
};

FaqBreadcrumb.propTypes = {
  category: PropTypes.string,
  themes: PropTypes.string.isRequired,
};

FaqBreadcrumb.defaultProps = {
  category: '',
};

export default FaqBreadcrumb;
